import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { SYS_ADMIN } from 'config/permissions/roles';
import reportsComponent from './reports.component';

import administrationsByCategoryArea from './admins-by-category-area/admins-by-category-area.module';
import administrationsByCategoryBar from './admins-by-category-bar/admins-by-category-bar.module';
import administrationsByCategoryPie from './admins-by-category-pie/admins-by-category-pie.module';
import adminTrend from './admin-trend/admin-trend.module';
import ingredientRisk from './ingredient-risk/ingredient-risk.module';
import reportForm from './report-form/report-form.module';
import riskByYear from './risk-by-year/risk-by-year.module';
import seriousRiskByYear from './serious-risk-by-year/serious-risk-by-year.module';
import systemMetrics from './system-metrics/system-metrics.module';

import './reports.scss';

export default
  angular.module('components.reports', [
    uiRouter,
    administrationsByCategoryArea,
    administrationsByCategoryBar,
    administrationsByCategoryPie,
    adminTrend,
    ingredientRisk,
    reportForm,
    riskByYear,
    seriousRiskByYear,
    systemMetrics
  ])
    .component('reports', reportsComponent)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('reports', {
          parent: 'app',
          url: '/reports',
          component: 'reports',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          },
          resolve: {
            reportTypes: ReportService => ReportService.getReportTypes().filter(r => r.enabled).sort((a, b) => {
              const nameA = a.name.toLowerCase();
              const nameB = b.name.toLowerCase();
              if (nameA < nameB) return -1;
              if (nameA > nameB) return 1;
              return 0;
            }),
            flex: () => '100',
            layout: () => 'column'
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/reports/reports.module.js